<section class="ticket-system-wrap">
    <div class="choose-system" *ngIf="systemOptions.length > 1">
        <div class="title" (click)="showHideSystemOptions()">
            <span i18n="Select System Type ticket calculator@@SelectSystemTypeButton">Odabir sistema</span>
            <i class="arrow-down icon icon-chevron-down" [class.closed]="showSystemOptions"></i>
        </div>
        <div class="system-option" *ngIf="showSystemOptions || superBetMessageType != superbetMessageTypeEnum.NONE">
          <div *ngIf="superBetMessageType != superbetMessageTypeEnum.NONE">{{superBetMsg}}</div>
            <ul class="system-list-wrap">
                <ng-container *ngFor="let sysOpt of systemOptions; let i = index;">
                    <li class="sys-checkbox-wrap" *ngIf="sysOpt.isSuperBetConditionFulfilled && superBetMessageType == superbetMessageTypeEnum.NONE"
                        [class.disabled]="ticketData.numberOfBets+sysOpt.numberOfCombinations > CV.MAX_COMBINATIONS && !sysOpt.optionSelected">
                        <input id="sys-{{i}}" type="checkbox" (change)="checkbox(sysOpt)" [checked]="sysOpt.optionSelected">
                        <label [attr.for]="'sys-'+i">
                            <span class="sys-opt"><span *ngIf="bankerTicketItemGroups.length > 0">F{{bankerTicketItemGroups.length}}+</span>{{sysOpt.eventsInCombination}}/{{sysOpt.totalNumberOfEvents}}</span>
                            <span class="order">{{i+1}}</span>
                        </label>
                     </li>
                </ng-container>
            </ul>
        </div>
    </div>

    <div class="ticket-info-box" *ngIf="ticketData.numberOfBets > 1">
        <div>
            <span i18n="Number of combinations ticket calculator@@NumberOfCombinatuionsMob">Ukupno kombinacija</span>
            <span>{{ticketData.numberOfBets}}</span>
        </div>

        <div>
            <span i18n="Stake per combination ticket calculator@@StakePerCombinationMob">Ulog po kombinaciji</span>
            <span>{{wagerPerBetString | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
    </div>

    <div class="bold color input-wrap" class="ticket-info-row border stake-wrap">
        <span class="bold" i18n="Total Stake ticket calculator@@TotalStake">UPLATA</span>

        <!-- <div class="input-wrap" *ngFor="let denomination of predefinedDenominations; let i = index;">
          <button [class.clicked]="clickedDenomination == i" class="denomination-button" (click)="clickedDenomination = i ;setDenomination(denomination)" >{{denomination}}</button>
        </div> -->
        <div class="denomination-wrap">
          <div class="denomination-button" *ngFor="let denomination of predefinedDenominations; let i = index;" [class.selected]="ticketData.payin == denomination" (click)="setDenomination(denomination)">{{denomination}}</div>

        </div>

        <!-- <span class="bold color">{{totalStake | number: displayFormat}} {{CV.CURRENCY}}</span> -->
        <span class="bold color input-wrap">
            <input id="totalStakeInput" type="text" inputmode="decimal" pattern="[0-9]*" numberOnly="true" [(ngModel)]="payin" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input" (focus)="focusStakeInput()" (focusout)="outOfFocusStakeInput()">
            {{CV.CURRENCY}}
            <!-- <input id="totalStakeInput" type="number" inputmode="decimal" pattern="[0-9]*" [(ngModel)]="payin" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input form-control form-control-sm" autocomplete="off" (focus)="focusStakeInput()" (focusout)="outOfFocusStakeInput()"> -->
        </span>

    </div>


    <div class="ticket-info-row" *ngIf="ticketData.bonus > 0">
       <span><span><ng-container i18n="Bonus ticket calculator@@Bonus">Bonus</ng-container>:</span>  ({{ticketData.bonusPercent}}%) </span>
        <span>{{ticketData.bonus | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>



    <ng-container *ngIf="ticketData.numberOfBets > 1; else ticketFix">
      <div class="ticket-info-row">
        <span>
           <span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog</span>
            <span *ngIf="taxBeforeStakeDefinitionPercent"> (-{{taxBeforeStakeDefinitionPercent}}% mt)</span>:
        </span>
        <span>{{ticketData.totalStake | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
      <div class="ticket-info-row">
        <span><span i18n="Win ticket calculator@@Win">Dobitak</span>:</span>
        <span>{{ticketData.possibleWin | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
      <div class="ticket-info-row">
        <span><span i18n="Tax on winnings@@TaxOnWinings">Porez</span>:</span>
        <span>{{ticketData.taxOnWinings | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>


    </ng-container>

    <ng-template #ticketFix>
      <div class="ticket-info-row">
        <span>
          <span><span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog</span>:</span>
          <span *ngIf="taxBeforeStakeDefinitionPercent">(-{{taxBeforeStakeDefinitionPercent}}% mt)</span>
        </span>
        <span>{{ticketData.totalStake | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
      <div class="ticket-info-row">
        <span><span i18n="Win ticket calculator@@Win">Dobitak</span>:</span>
        <span>{{ticketData.possibleWin | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
      <div class="ticket-info-row">
        <span><span i18n="Tax on winnings@@TaxOnWinings">Porez</span>:</span>
        <span>{{ticketData.taxOnWinings | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
    </ng-template>


    <div class="ticket-info-row small" *ngIf="ticketData.numberOfBets > 1 && viewConfigurations.showBonusMessageOnSystemTicket">
        <span i18n="System ticket description@@SystemDescription">* potencijalni BONUS se obračunava pri finalnoj obradi sistemskog tiketa</span>
    </div>

    <div class="ticket-info-row highlight" (click)="ticketData.numberOfBets> 1? showPayoutInfos = !showPayoutInfos : showPayoutInfos = showPayoutInfos; $event.stopPropagation();">
      <div>
        <span i18n="Total Odd ticket calculator@@TotalOdd">Tečaj</span>:
        <span class="color"> {{ticketData.totalOdd | number:'1.2-2'}}</span>
      </div>

      <div class="flex">
        <div class="right-content">
          <span i18n="Possible paout ticket calculator@@PossiblePayout">Ev. Isplata</span>:
          <span class="bold color"> {{ticketData.possibleWinWithoutTax | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
        <div>
          <!-- <i class="arrow-down icon icon-chevron-up" [class.closed]="!showPayoutInfos"></i> -->
          <i *ngIf="ticketData.numberOfBets > 1" class="arrow-down icon" [ngClass]="{'icon-chevron-up': showPayoutInfos, 'icon-chevron-down': !showPayoutInfos }"></i>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showPayoutInfos && ticketData.numberOfBets > 1">
      <div class="ticket-info-row" *ngIf="ticketData.possibleWinWithoutTax!=ticketData.possibleMinPayout">
        <span><span i18n="Min possible payout shorted@@MinPossiblePayoutShorted">Min isplata</span>:</span>
        <span>{{ticketData.possibleMinPayout | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
      <div class="ticket-info-row" *ngIf="ticketData.totalWinings > 0">
        <span><span i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">Max isplata</span>:</span>
        <span>{{ticketData.possibleWinWithoutTax | number: displayFormat}} {{CV.CURRENCY}}</span>
      </div>
      <app-winnings-per-hit  *ngIf="ticketData.possibleWinForNumberOfHits?.length > 1" [possibleWinForNumberOfHits]="ticketData.possibleWinForNumberOfHits"> </app-winnings-per-hit>
    </ng-container>



    <div class="ticket-info-row">
        <!-- <button id="placeBet" *ngIf="isTicketOnline && ((numberOfBets > 0 && totalStake >= CV.MIN_STAKE && wagerPerBet >= CV.MIN_STAKE_PER_COMB && numberOfBets <= CV.MAX_COMBINATIONS)); else offilneButton"
            (click)="placeBet()" i18n="Proceed to payment ticket calculator button@@ProceedToPayment">PRIPREMA ZA UPLATU</button> -->
        <ng-container *ngIf="isTicketOnline && ((ticketData.numberOfBets > 0 && payin >= CV.MIN_STAKE && wagerPerBet >= CV.MIN_STAKE_PER_COMB && ticketData.numberOfBets <= CV.MAX_COMBINATIONS)); else offilneButton">

        </ng-container>

        <ng-template #offilneButton>
            <!-- <span *ngIf="!isTicketOnline; else onlineWithRestictions">OFFLINE događaji na tiketu</span> -->
            <ng-template #onlineWithRestictions>
                <!-- <span *ngIf="numberOfBets == 0; else betsNumNotZero">ODABERITE TIP SISTEMA</span> -->
                <ng-template #betsNumNotZero>
                    <ng-container *ngIf="ticketData.numberOfBets > CV.MAX_COMBINATIONS; else betsNumGood">
                        <span i18n="Max Number of combinations ticket calculator button@@MaxNumOfCombinations">MAX KOMBINACIJA</span>:
                        <span class="bold">{{CV.MAX_COMBINATIONS}}</span>
                    </ng-container>
                    <ng-template #betsNumGood>
                        <ng-container *ngIf="CV.MIN_STAKE > payin; else minStakeGood">
                            <span i18n="Min stake ticket calculator button@@MinStake">MIN UPLATA</span>
                            <span class="bold">{{CV.MIN_STAKE}} {{CV.CURRENCY}}</span>
                        </ng-container>
                        <ng-template #minStakeGood>
                            <span i18n="Min stake per bet calculator button@@MinStakePerBet">MIN UPLATA PO BETU</span>
                            <span class="bold">{{CV.MIN_STAKE_PER_COMB}} {{CV.CURRENCY}}</span>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-template>
        </ng-template>
    </div>
    <div class="radio-wrap">
      <div class="custom-radio mobileV2" *ngIf="isUserLoggedIn && accountBalance >= ticketData.totalStake" >
          <input type="radio" id="typeOfplaceBet4"  name="typeOfplaceBet1" [value]="placeBetTypeEnum.Standard" [(ngModel)]="placeBetType" >
          <label for="typeOfplaceBet4" i18n="Pay in from web@@PayInFromWeb">uplati s web računa</label>
      </div>

      <div class="custom-radio mobileV2">
          <input type="radio" id="typeOfplaceBet5" name="typeOfplaceBet1" [value]="placeBetTypeEnum.Express" [attr.checked]="placeBetType.valueOf() == placeBetTypeEnum.Standard" [(ngModel)]="placeBetType">
          <label for="typeOfplaceBet5" i18n="Pay in at shop@@PayInAtShop">uplati u poslovnici</label>
      </div>

      <div *ngIf="isUserLoggedIn && ticketData.freeBetValue > 0 && freeBetBalance >= ticketData.payin" class="custom-radio mobileV2">
        <input type="radio" id="typeOfplaceBet6"  name="typeOfplaceBet1" [value]="placeBetTypeEnum.FreeBet" [(ngModel)]="placeBetType">
        <label for="typeOfplaceBet6" i18n="ticket Confirm FreeBet Ticket button@@ConfirmTicketFreeBetTicket">free bet</label>
      </div>

  </div>
</section>

